import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormSubmitData,
  hideFormModalIfNoErrors,
  setFormLoadingState,
} from '@shared/components/radar-form-abstract';
import { Subscription } from 'rxjs';
import { GlobalSearchResultNode, LeadNode } from '@generated/graphql';
import { GlobalSearchService } from '@ui/global-search/services/global-search.service';
import { DropdownAbstractClass } from '@ui/components/dropdown-abstract';
import { GlobalSearchForm } from '@ui/global-search/components/global-search-form/global-search-form.component';
import { Router } from '@angular/router';
import { ModalV2Service } from '@voyagu/radar-design-system';

@Component({
  selector: 'global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalSearchComponent extends DropdownAbstractClass {
  results: GlobalSearchResultNode[] = [];
  isEmpty = false;
  loading = false;
  searchSub: Subscription;

  data: any = {};

  selectedLead: LeadNode;
  @ViewChild('assignLeadForm') assignLeadForm: TemplateRef<unknown>;

  globalSearchService = inject(GlobalSearchService);
  router = inject(Router);
  modalV2Service = inject(ModalV2Service);

  constructor(elRef: ElementRef, cdRef: ChangeDetectorRef) {
    super(elRef, cdRef);
  }

  fetchData(term: string) {
    this.searchSub?.unsubscribe();
    this.loading = true;
    this.results = [];
    this.isEmpty = false;

    this.searchSub = this.globalSearchService.search(term).subscribe({
      next: (chunk) => {
        this.results = [...this.results, ...chunk];
        this.cdRef.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.isEmpty = !this.results.some((result) => result.items?.length);
        this.cdRef.markForCheck();
      },
      complete: () => {
        this.loading = false;
        this.isEmpty = !this.results.some((result) => result.items?.length);
        this.cdRef.markForCheck();
      },
    });
  }

  clearSearch() {
    this.data = {};
    this.toggleCollapsed();
  }

  outsideClickHandler(event: MouseEvent) {
    super.outsideClickHandler(event);
    if (this.collapsed) {
      this.data = {};
    }
  }

  submit({ data }: FormSubmitData<GlobalSearchForm>) {
    if (data.search) {
      if (this.collapsed) {
        this.toggleCollapsed();
      }

      this.fetchData(data.search);
    }
  }

  assignLead(selectedLead: LeadNode) {
    this.selectedLead = selectedLead;

    this.modalV2Service.showModal({ template: this.assignLeadForm });
  }

  hideModal() {
    this.modalV2Service.hideFirst();
  }

  submitAssignLead({ data }: FormSubmitData) {
    const input = { leadId: this.selectedLead.id, contactedBy: data['contactedBy'] };

    this.globalSearchService
      .assignLead({ input })
      .pipe(hideFormModalIfNoErrors(), setFormLoadingState(false))
      .subscribe((ok) => {
        if (ok) {
          void this.router.navigate([`/leads/${this.selectedLead.id}`]);
        }
      });
  }
}
